import axios from '@/libs/api.request'

// 查询模板列表
export const planMouldList = data => {
  return axios.request({
    url: '/planning/template/page',
    data,
    method: 'POST'
  })
}
// 新增模板
export const planMouldName = data => {
  return axios.request({
    url: '/planning/template/add',
    data,
    method: 'POST'
  })
}
// 模板重命名
export const planMouldRename = data => {
  return axios.request({
    url: '/planning/template/rename',
    data,
    method: 'POST'
  })
}
// 模板失效
export const planMouldInvalid = data => {
  return axios.request({
    url: '/planning/template/invalid',
    data,
    method: 'POST'
  })
}
// 查询成绩列表
export const planScoreList = data => {
  return axios.request({
    url: '/planning/template/score/list',
    data,
    method: 'POST'
  })
}
// 查询列表todo
export const planTodosList = data => {
  return axios.request({
    url: '/planning/template/todos/list',
    data,
    method: 'POST'
  })
}
// 查询类目信息列表
export const planCategoryList = data => {
  return axios.request({
    url: '/planning/template/category/list',
    data,
    method: 'POST'
  })
}
// 查询目标信息列表
export const planTargetList = data => {
  return axios.request({
    url: '/planning/template/target/list',
    data,
    method: 'POST'
  })
}
// 查询完成度列表
export const planDegreeList = data => {
  return axios.request({
    url: '/planning/template/degree/list',
    data,
    method: 'POST'
  })
}
// 添加成绩信息
export const planAddScore = data => {
  return axios.request({
    url: '/planning/template/add/score',
    data,
    method: 'POST'
  })
}
// 修改成绩信息
export const planModifyScore = data => {
  return axios.request({
    url: '/planning/template/modify/score',
    data,
    method: 'POST'
  })
}
// 删除成绩信息
export const planDeleteScore = data => {
  return axios.request({
    url: '/planning/template/delete/score',
    data,
    method: 'POST'
  })
}
// 添加类目信息
export const planAddCategory = data => {
  return axios.request({
    url: '/planning/template/add/category',
    data,
    method: 'POST'
  })
}
// 修改类目信息
export const planModifyCategory = data => {
  return axios.request({
    url: '/planning/template/modify/category',
    data,
    method: 'POST'
  })
}
// 删除类目信息
export const planDeleteCategory = data => {
  return axios.request({
    url: '/planning/template/delete/category',
    data,
    method: 'POST'
  })
}
// 添加目标信息
export const planAddTarget = data => {
  return axios.request({
    url: '/planning/template/add/target',
    data,
    method: 'POST'
  })
}
// 修改目标信息
export const planModifyTarget = data => {
  return axios.request({
    url: '/planning/template/modify/target',
    data,
    method: 'POST'
  })
}
// 删除目标信息
export const planDeleteTarget = data => {
  return axios.request({
    url: '/planning/template/delete/target',
    data,
    method: 'POST'
  })
}
// 添加todos信息
export const planAddTodos = data => {
  return axios.request({
    url: '/planning/template/add/todos',
    data,
    method: 'POST'
  })
}
// 修改todos信息
export const planModifyTodos = data => {
  return axios.request({
    url: '/planning/template/modify/todos',
    data,
    method: 'POST'
  })
}
// 删除todos信息
export const planDeleteTodos = data => {
  return axios.request({
    url: '/planning/template/delete/todos',
    data,
    method: 'POST'
  })
}

// 添加完成度信息
export const planAddDegree = data => {
  return axios.request({
    url: '/planning/template/add/degree',
    data,
    method: 'POST'
  })
}
// 修改完成度信息
export const planModifyDegree = data => {
  return axios.request({
    url: '/planning/template/modify/degree',
    data,
    method: 'POST'
  })
}
// 删除完成度信息
export const planDeleteDegree = data => {
  return axios.request({
    url: '/planning/template/delete/degree',
    data,
    method: 'POST'
  })
}

// 获取阶段1信息
export const planQueryPhasesList = data => {
  return axios.request({
    url: '/planning/query/phases/list',
    data,
    method: 'POST'
  })
}
// 获取阶段2信息
export const planQueryPhasesListParent = data => {
  return axios.request({
    url: '/planning/query/phases/list/by/parent',
    data,
    method: 'POST'
  })
}
// 获取规划内阶段列表，跟进记录下拉框调用
export const planQueryPhasesListAudit = data => {
  return axios.request({
    url: '/planning/query/planning/phases/list',
    data,
    method: 'POST'
  })
}

// 学员规划
// 学员列表
export const planMenteeList = data => {
  return axios.request({
    url: '/planning/query/mentee/list',
    data,
    method: 'POST'
  })
}
// 创建规划
export const planCreate = data => {
  return axios.request({
    url: '/planning/create',
    data,
    method: 'POST'
  })
}
// 沿用模板
export const planFollowTemplate = data => {
  return axios.request({
    url: '/planning/follow/template',
    data,
    method: 'POST'
  })
}
// 成绩列表
export const planQueryScoreList = data => {
  return axios.request({
    url: '/planning/query/score/list',
    data,
    method: 'POST'
  })
}
// 类目列表
export const planQueryCategoryList = data => {
  return axios.request({
    url: '/planning/query/category/list',
    data,
    method: 'POST'
  })
}
// 查询目标信息列表
export const planQueryTargetList = data => {
  return axios.request({
    url: '/planning/query/target/list',
    data,
    method: 'POST'
  })
}
// 查询成绩todos列表
export const planQueryScoreTodosList = data => {
  return axios.request({
    url: '/planning/query/score/todos/list',
    data,
    method: 'POST'
  })
}
// 查询成绩外todos列表
export const planQueryOtherTodosList = data => {
  return axios.request({
    url: '/planning/query/other/todos/list',
    data,
    method: 'POST'
  })
}
// 申请时间表
export const planQueryInfoPhasesList = data => {
  return axios.request({
    url: '/planning/query/info/list/by/phases',
    data,
    method: 'POST'
  })
}
// 协议更新阶段
export const planModifyPhases = data => {
  return axios.request({
    url: '/planning/modify/phases',
    data,
    method: 'POST'
  })
}
// 添加成绩信息
export const planMenteeAddScore = data => {
  return axios.request({
    url: '/planning/core/add/score',
    data,
    method: 'POST'
  })
}
// 修改成绩信息
export const planMenteeModifyScore = data => {
  return axios.request({
    url: '/planning/core/modify/score',
    data,
    method: 'POST'
  })
}
// 删除成绩信息
export const planMenteeDeleteScore = data => {
  return axios.request({
    url: '/planning/core/delete/score',
    data,
    method: 'POST'
  })
}
// 添加类目信息
export const planMenteeAddCategory = data => {
  return axios.request({
    url: '/planning/add/category',
    data,
    method: 'POST'
  })
}
// 修改类目信息
export const planMenteeModifyCategory = data => {
  return axios.request({
    url: '/planning/modify/category',
    data,
    method: 'POST'
  })
}
// 添加目标信息
export const planMenteeAddTarget = data => {
  return axios.request({
    url: '/planning/core/add/target',
    data,
    method: 'POST'
  })
}
// 修改目标信息
export const planMenteeModifyTarget = data => {
  return axios.request({
    url: '/planning/core/modify/target',
    data,
    method: 'POST'
  })
}
// 删除目标信息
export const planMenteeDeleteTarget = data => {
  return axios.request({
    url: '/planning/core/delete/target',
    data,
    method: 'POST'
  })
}
// 添加todo信息
export const planMenteeAddTodos = data => {
  return axios.request({
    url: '/planning/core/add/todos',
    data,
    method: 'POST'
  })
}
// 修改todo信息
export const planMenteeModifyTodos = data => {
  return axios.request({
    url: '/planning/core/modify/todos',
    data,
    method: 'POST'
  })
}
// 删除todo信息
export const planMenteeDeleteTodos = data => {
  return axios.request({
    url: '/planning/core/delete/todos',
    data,
    method: 'POST'
  })
}
// 完成todo信息
export const planMenteeFinishTodos = data => {
  return axios.request({
    url: '/planning/core/finish/todo',
    data,
    method: 'POST'
  })
}
// 发起审核
export const planMenteeAuditApply = data => {
  return axios.request({
    url: '/planning/audit/apply',
    data,
    method: 'POST'
  })
}
// 审核通过
export const planMenteeAuditPass = data => {
  return axios.request({
    url: '/planning/audit/pass',
    data,
    method: 'POST'
  })
}
// 审核失败
export const planMenteeAuditReject = data => {
  return axios.request({
    url: '/planning/audit/reject',
    data,
    method: 'POST'
  })
}
// 发送给学生
export const planMenteeAuditSend = data => {
  return axios.request({
    url: '/planning/audit/send',
    data,
    method: 'POST'
  })
}
// 获取模板列表信息
export const planMenteeTemplateList = data => {
  return axios.request({
    url: '/planning/template/list',
    data,
    method: 'POST'
  })
}
// 获取规划详情
export const planMenteeQueryDetail = data => {
  return axios.request({
    url: '/planning/query/detail',
    data,
    method: 'POST'
  })
}

// 获取当前阶段规划信息
export const planMenteeCurrentPhases = data => {
  return axios.request({
    url: '/planning/query/current/phases',
    data,
    method: 'POST'
  })
}
// 获取当前阶段规划信息
export const planMenteePhasesInfo = data => {
  return axios.request({
    url: '/planning/query/phases/info',
    data,
    method: 'POST'
  })
}
